import { SelectSheetOption } from "../../../../../components/MobileForm/types";
import { Holding } from "../../../../../services/holdings";
import { holdingOpenedText } from "../../../utils";

// A reopened instrument is a second holding with the same symbol and name, so only those carry the opened date.
export const activityHoldingOptionsOf = (
  holdings: Holding[],
): SelectSheetOption[] => {
  const holdingCountByInstrument = new Map<number, number>();
  for (const { instrument } of holdings) {
    holdingCountByInstrument.set(
      instrument.id,
      (holdingCountByInstrument.get(instrument.id) ?? 0) + 1,
    );
  }

  return holdings.map((holding) => {
    const label = `${holding.instrument.symbol} · ${holding.instrument.name}`;
    const isReopened =
      (holdingCountByInstrument.get(holding.instrument.id) ?? 0) > 1;
    return {
      value: String(holding.id),
      label: isReopened
        ? `${label} · ${holdingOpenedText(holding.openedAt)}`
        : label,
    };
  });
};
